import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'answered',
  type: 'call',
  access: 'causes',
}

const formatting = {
  format: {
    title: 'Answered',
  },
}

const keys = {
  statKey: 'normal_clearing',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const answered = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { answered }
